import { Chip } from '@/components/DesignSystem';
import { ChurnStatus, ChurnStatusDetails } from '@shared/enums';
import { getChurnStatusColor } from '@/utilities/ChurnStatusColor';
import { useTheme } from '@mui/material';

type ChurnStatusChipProps = {
  status: ChurnStatus,
  useCustomLabels?: boolean,
};

export const ChurnStatusChip: React.FC<ChurnStatusChipProps> = ({ 
  status, 
  useCustomLabels = false,
}) => {

  const theme = useTheme();

  if (!status || status === ChurnStatus.NoRisk) {
    return <span></span>;
  }
  const { background, color } = getChurnStatusColor(status, theme);
  const chipLabel = useCustomLabels 
    ? `${ChurnStatusDetails[status]?.label.toUpperCase()} (BETA)`
    : status;
  return (
      <Chip
        label={chipLabel}
        size='small'
        sx={{
          background,
          fontSize: '11px',
          fontWeight: 500,
          lineHeight: '11px',
          height: '16px',
          padding: '0px 6px !important',
          borderRadius: '100px',
          letterSpacing: '0.5px',
          textTransform: 'uppercase',
          ...(color && { color }),
        }}
        testID={`${status}-churn-chip`}
      />
  );
};
